import React from 'react';
import { theme } from '../styles/theme';
import Container from '../components/ui/Container';
import FooterPageContent from '../components/layout/FooterPageContent';

const AboutPage = () => {
  const pageStyles = {
    padding: `${theme.spacing.xxl} 0`,
    backgroundColor: theme.colors.background,
    minHeight: '100vh',
  };

  const contentStyles = {
    maxWidth: '900px',
    margin: '0 auto',
    padding: `0 ${theme.spacing.lg}`,
  };

  const headingStyles = {
    fontFamily: theme.typography.fontFamily.primary,
    fontSize: theme.typography.fontSize.xxl,
    fontWeight: theme.typography.fontWeight.bold,
    color: theme.colors.primary,
    marginBottom: theme.spacing.lg,
    textAlign: 'center',
  };

  const subHeadingStyles = {
    fontFamily: theme.typography.fontFamily.primary,
    fontSize: theme.typography.fontSize.xl,
    fontWeight: theme.typography.fontWeight.semibold,
    color: theme.colors.primaryDark,
    marginTop: theme.spacing.xl,
    marginBottom: theme.spacing.md,
  };

  const paragraphStyles = {
    fontSize: theme.typography.fontSize.base,
    lineHeight: theme.typography.lineHeight.relaxed,
    color: theme.colors.text,
    marginBottom: theme.spacing.md,
  };

  const contactBoxStyles = {
    backgroundColor: theme.colors.neutral,
    padding: theme.spacing.lg,
    borderRadius: theme.borderRadius.md,
    marginTop: theme.spacing.xl,
    marginBottom: theme.spacing.lg,
  };

  return (
    <div style={pageStyles}>
      <Container>
        <div style={contentStyles}>
          <h1 style={headingStyles}>About BS Trading Co.</h1>

          {/* CMS or Default Content */}
          <FooterPageContent slug="about">

          <p style={paragraphStyles}>
            Welcome to BS Trading Co., your trusted source for quality Western goods, cowhides, furniture, 
            furs, rugs, and trading supplies. For years, we've been dedicated to providing our customers 
            with exceptional products that embody the spirit and heritage of the American West.
          </p>

          <h2 style={subHeadingStyles}>Our Story</h2>
          <p style={paragraphStyles}>
            BS Trading Co. has built its reputation on quality, authenticity, and customer service. 
            Located in the heart of Texas, we understand the needs of ranchers, traders, decorators, 
            and Western enthusiasts alike. Our extensive inventory includes everything from premium 
            cowhides and exotic furs to rustic furniture and traditional trading supplies.
          </p>

          <h2 style={subHeadingStyles}>What We Offer</h2>
          <p style={paragraphStyles}>
            Our product selection includes:
          </p>
          <ul style={{
            fontSize: theme.typography.fontSize.base,
            lineHeight: theme.typography.lineHeight.relaxed,
            color: theme.colors.text,
            marginBottom: theme.spacing.md,
            paddingLeft: theme.spacing.xl,
          }}>
            <li>Premium cowhides and exotic hides</li>
            <li>Western furniture and home décor</li>
            <li>Furs and pelts</li>
            <li>Rugs and floor coverings</li>
            <li>Trading supplies and accessories</li>
            <li>Custom orders and special requests</li>
          </ul>

          <h2 style={subHeadingStyles}>Our Commitment</h2>
          <p style={paragraphStyles}>
            At BS Trading Co., we're committed to providing authentic, high-quality products at 
            competitive prices. Whether you're a wholesale buyer, interior designer, or individual 
            customer, we treat every order with the same level of care and attention to detail.
          </p>

          <p style={paragraphStyles}>
            We pride ourselves on our knowledgeable staff who can help you find exactly what you need, 
            whether you're shopping in person or online. Our team is always ready to answer questions 
            and provide expert guidance on product selection and care.
          </p>

          <h2 style={subHeadingStyles}>Visit Us or Get in Touch</h2>
          <p style={paragraphStyles}>
            We welcome visitors to our location in Burleson, Texas, where you can see our products 
            in person and experience the quality firsthand. Can't make it in? No problem – we're 
            here to help by phone or email.
          </p>

          <div style={contactBoxStyles}>
            <p style={{ ...paragraphStyles, marginBottom: theme.spacing.xs }}>
              <strong>BS Trading Co.</strong>
            </p>
            <p style={{ ...paragraphStyles, marginBottom: theme.spacing.xs }}>253 Loy St</p>
            <p style={{ ...paragraphStyles, marginBottom: theme.spacing.xs }}>Burleson, TX 76028</p>
            <p style={{ ...paragraphStyles, marginBottom: theme.spacing.xs }}>
              <strong>Phone:</strong> 817-447-4433
            </p>
            <p style={{ ...paragraphStyles, marginBottom: theme.spacing.xs }}>
              <strong>Toll-Free:</strong> 1-800-554-0910
            </p>
            <p style={{ ...paragraphStyles, marginBottom: theme.spacing.xs }}>
              <strong>Email:</strong> <a href="mailto:Orders@BSTrading.com" style={{ color: theme.colors.primary }}>Orders@BSTrading.com</a>
            </p>
            <p style={{ ...paragraphStyles, marginBottom: 0 }}>
              <strong>Hours:</strong> Monday - Friday, 8:00 AM - 5:00 PM CST
            </p>
          </div>

          <p style={paragraphStyles}>
            Thank you for choosing BS Trading Co. We look forward to serving you!
          </p>
          </FooterPageContent>
        </div>
      </Container>
    </div>
  );
};

export default AboutPage;

